import { IconStatusNew, Text, TextTypes } from '@genial/components';

export interface ObservationsProps {
  observations?: string;
  textProps?: TextTypes.Props;
}

export const Observations = ({ observations, textProps }: ObservationsProps) => {
  if (!observations) {
    return <IconStatusNew color="scale.base.400" icon="MinusCircle" status="Sem Observações" />;
  }

  return (
    <Text fontSize="xs" {...textProps}>
      {observations}
    </Text>
  );
};
